import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Meta, Display, Button, Card, PageTitle, Icons, Chip } from '../components/Atoms';
import Layout, { TopBar } from '../components/Layout';
import { LoadingState, EmptyState } from '../components/states';
import { useApi } from '../lib/api';
import axios from '../../config/axios';
import CommunityTabs from '../components/CommunityTabs';


function ListingMessages({ listingId, currentUserId }) {
  const [msgs, setMsgs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);
  const [err, setErr] = useState('');
  const [open, setOpen] = useState(false);

  const loadThread = async () => {
    if (loading) return;
    setLoading(true); setErr('');
    try {
      const res = await axios.get(`/api/listings/${listingId}/thread`);
      setMsgs(res.data);
      setOpen(true);
    } catch (e) { setErr(e.response?.data?.error || 'Nie udało się wczytać wiadomości. Odśwież i spróbuj ponownie.'); }
    setLoading(false);
  };

  const send = async () => {
    if (!text.trim() || sending) return;
    setSending(true); setErr('');
    try {
      await axios.post(`/api/listings/${listingId}/message`, { body: text.trim() });
      setText('');
      loadThread();
    } catch (e) { setErr(e.response?.data?.error || 'Nie udało się wysłać wiadomości. Spróbuj ponownie.'); }
    setSending(false);
  };

  if (!open) {
    return <button type="button" onClick={loadThread} style={{ marginTop: 8, padding: '6px 12px', borderRadius: 6, background: 'var(--t-sage)', color: 'var(--t-bg)', border: 'none', cursor: 'pointer', fontSize: 11, display: 'inline-flex', alignItems: 'center', gap: 6 }}><Icons.Journal size={14} />Wiadomości</button>;
  }

  return (
    <Card style={{ marginTop: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
        <Meta><Icons.Journal size={12} style={{ marginRight: 4 }} />Wątek</Meta>
        <button type="button" onClick={() => setOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 14 }} aria-label="Zamknij wątek">✕</button>
      </div>
      {loading ? <LoadingState /> : err ? <div style={{ color: 'var(--t-rust)', fontSize: 12 }}>{err}</div> : (
        <div style={{ maxHeight: 200, overflow: 'auto', marginBottom: 8 }}>
          {msgs.length === 0 ? <EmptyState title="Brak wiadomości" description="Bądź pierwszym!" /> : msgs.map(m => (
            <div key={m.id} style={{ padding: '6px 8px', marginBottom: 4, borderRadius: 4, background: m.sender_id === currentUserId ? 'var(--t-sage-bg)' : 'var(--t-dim-bg)' }}>
              <div style={{ fontSize: 10, color: 'var(--t-text-mute)' }}>{m.sender_username} · {m.created_at?.slice(0,16).replace('T', ' ')}</div>
              <div style={{ fontSize: 13, color: 'var(--t-text)' }}>{m.body}</div>
            </div>
          ))}
        </div>
      )}
      <div style={{ display: 'flex', gap: 8 }}>
        <input type="text" aria-label="Treść wiadomości" value={text} onChange={e => setText(e.target.value)} placeholder="Napisz wiadomość…" maxLength={500} onKeyDown={e => e.key === 'Enter' && send()} style={{ flex: 1, padding: '6px 10px', borderRadius: 6, background: 'var(--t-bg)', border: '1px solid var(--t-line-2)', fontSize: 13 }} />
        <Button variant="primary" onClick={send} disabled={sending || !text.trim()} style={{ padding: '6px 12px', fontSize: 11, height: 'auto' }}>{sending ? '…' : 'Wyślij'}</Button>
      </div>
    </Card>
  );
}

export default function Listings() {
  const { data: mine, loading, refetch } = useApi('/api/listings/mine');
  const { data: meData } = useApi('/api/auth/me');
  const currentUserId = meData?.user?.id;
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ type: 'give', title: '', plant_name: '', quantity: '', price: '', description: '', city: '' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!form.type || !form.title) return;
    setSaving(true); setMsg('');
    try {
      await axios.post('/api/listings', form);
      setShowForm(false);
      setForm({ type: 'give', title: '', plant_name: '', quantity: '', price: '', description: '', city: '' });
      refetch();
    } catch (err) { setMsg(err.response?.data?.error || 'Nie udało się dodać ogłoszenia. Sprawdź dane i spróbuj ponownie.'); }
    setSaving(false);
  };

  const closeListing = async (id) => {
    try { await axios.post(`/api/listings/${id}/close`); refetch(); } catch {}
  };

  const deleteListing = async (id) => {
    try { await axios.delete(`/api/listings/${id}`); refetch(); } catch {}
  };

  const items = Array.isArray(mine) ? mine : [];

  return (
    <Layout topBar={<TopBar left={<Meta>Społeczność</Meta>} />}>
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '0 32px 60px' }}>
        <PageTitle
          eyebrow="Społeczność"
          title="Giełda roślin"
          sub="Wystaw ogłoszenie dla znajomych: sprzedaj, wymień lub oddaj rośliny, nasiona, rozsadę."
        />

        <CommunityTabs active="gielda" />

        {msg && <div style={{ padding: '10px 14px', borderRadius: 8, marginBottom: 16, background: (msg.includes('Błąd') || msg.includes('Nie udało')) ? 'var(--t-rust-bg)' : 'var(--t-sage-bg)', fontSize: 13 }}>{msg}</div>}

        <Button variant="primary" onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Anuluj' : '+ Nowe ogłoszenie'}
        </Button>

        {showForm && (
          <form onSubmit={submit} style={{ marginTop: 16, padding: 16, borderRadius: 12, background: 'var(--t-bg-elev)', border: '1px solid var(--t-line)' }}>
            <div style={{ display: 'grid', gap: 10, gridTemplateColumns: '1fr 1fr' }}>
              <select aria-label="Typ ogłoszenia" value={form.type} onChange={e => setForm({...form, type: e.target.value})} style={s}>
                <option value="give">Oddam</option>
                <option value="exchange">Wymienię</option>
                <option value="sell">Sprzedam</option>
              </select>
              <input aria-label="Tytuł ogłoszenia" placeholder="Tytuł *" value={form.title} onChange={e => setForm({...form, title: e.target.value})} style={s} />
              <input aria-label="Roślina" placeholder="Roślina" value={form.plant_name} onChange={e => setForm({...form, plant_name: e.target.value})} style={s} />
              <input aria-label="Ilość" placeholder="Ilość" value={form.quantity} onChange={e => setForm({...form, quantity: e.target.value})} style={s} />
              {form.type === 'sell' && <input type="number" aria-label="Cena w złotych" placeholder="Cena (zł)" value={form.price} onChange={e => setForm({...form, price: e.target.value})} style={s} />}
              <input aria-label="Miasto" placeholder="Miasto" value={form.city} onChange={e => setForm({...form, city: e.target.value})} style={s} />
            </div>
            <textarea aria-label="Opis ogłoszenia" placeholder="Opis" value={form.description} onChange={e => setForm({...form, description: e.target.value})} rows={3} style={{...s, marginTop: 10, width: '100%', resize: 'vertical'}} />
            <Button variant="primary" type="submit" disabled={saving || !form.title} style={{ marginTop: 10 }}>
              {saving ? '…' : 'Dodaj ogłoszenie'}
            </Button>
          </form>
        )}

        <div className="t-stagger">
          {loading ? <LoadingState /> : items.length === 0 ? (
            <EmptyState title="Brak ogłoszeń" description="Dodaj pierwsze ogłoszenie — znajomi zobaczą je w feedzie." />
          ) : items.map(l => (
            <Card key={l.id} style={{ marginTop: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <Meta>
                {l.type === 'sell' && <Chip tone="amber">{l.price || 0} zł</Chip>}
                {l.type === 'exchange' && <Chip tone="dim">Wymienię</Chip>}
                {l.type === 'give' && <Chip tone="sage">Oddam</Chip>}
              </Meta>
              <Chip tone={l.status === 'active' ? 'sage' : 'dim'}>{l.status === 'active' ? 'Aktywne' : 'Zamknięte'}</Chip>
            </div>
            <div style={{ fontSize: 14, color: 'var(--t-text)', marginBottom: 6 }}>{l.title}</div>
            {l.plant_name && (
              <div style={{ fontSize: 12, color: 'var(--t-text-dim)', marginBottom: 4 }}>
                <Icons.Sprout size={10} style={{ marginRight: 4 }} />{l.plant_name}{l.quantity ? ` · ${l.quantity}` : ''}
              </div>
            )}
            {l.city && <div style={{ fontSize: 11, color: 'var(--t-text-dim)', marginTop: 4 }}><Icons.Plot size={10} style={{ marginRight: 4, verticalAlign: 'text-bottom' }} />{l.city}</div>}
            {l.status === 'active' && (
              <div style={{ marginTop: 10, display: 'flex', gap: 8 }}>
                <button type="button" onClick={() => closeListing(l.id)} style={btnStyle}>Zamknij</button>
                <button type="button" onClick={() => deleteListing(l.id)} style={{...btnStyle, borderColor: 'var(--t-rust)', color: 'var(--t-rust)'}}>Usuń</button>
              </div>
            )}
            <ListingMessages listingId={l.id} currentUserId={currentUserId} />
          </Card>
        ))}
        </div>
      </div>
    </Layout>
  );
}

const s = { padding: '8px 10px', borderRadius: 6, background: 'var(--t-bg)', border: '1px solid var(--t-line-2)', color: 'var(--t-text)', fontSize: 13 };
const btnStyle = { padding: '6px 12px', borderRadius: 6, background: 'transparent', border: '1px solid var(--t-line-2)', color: 'var(--t-text-dim)', fontSize: 11, cursor: 'pointer', fontFamily: 'var(--t-mono)' };
